import { api } from '@/api/appGatewayServerApi'
import { isProduction } from '@/utils/env'

export const vliveIdKey = 'VLIVE_ID'

// sessionStoratgeにvliveIdが保存されていれば取得
// sessionStorageになく、かつtokenを取得できる場合はAPIリクエストで取得したvliveIdをsessionへ保存し返す
export const getVliveId = async () => {
  const vliveIdFromSession = sessionStorage.getItem(vliveIdKey)
  if (vliveIdFromSession) return vliveIdFromSession

  const fetchedVliveId = await fetchVliveIdForToken()
  if (!fetchedVliveId) return

  saveVliveId(fetchedVliveId)
  return fetchedVliveId
}

export const saveVliveId = (vliveId: string) => {
  sessionStorage.setItem(vliveIdKey, vliveId)
}

export const removeVliveId = () => {
  sessionStorage.removeItem(vliveIdKey)
}

const fetchVliveIdForToken = async (): Promise<string | undefined> => {
  try {
    const response = await api().streamer.owner.get({
      isLatestCounting: false,
    })
    return response.streamer.vliveId
  } catch (e) {
    if (!isProduction()) {
      // eslint-disable-next-line
      console.error('failed to fetch vliveId', e)
    }
    return
  }
}
